/* tslint:disable */
/* eslint-disable */
/**
 * BlackFriday API
 * The API Documentation for BlackFriday
 *
 * The version of the OpenAPI document: 0.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from "../runtime";
/**
 *
 * @export
 * @interface DescriptionRunEventDTO
 */
export interface DescriptionRunEventDTO {
  /**
   *
   * @type {number}
   * @memberof DescriptionRunEventDTO
   */
  id: number;
  /**
   *
   * @type {string}
   * @memberof DescriptionRunEventDTO
   */
  action: DescriptionRunEventDTOActionEnum;
  /**
   * Why nothing was written. Null on a written description.
   * @type {string}
   * @memberof DescriptionRunEventDTO
   */
  skipReason?: DescriptionRunEventDTOSkipReasonEnum;
  /**
   * The product this row is about. A historical reference — the page may since have been deleted.
   * @type {number}
   * @memberof DescriptionRunEventDTO
   */
  productId?: number | null;
  /**
   *
   * @type {string}
   * @memberof DescriptionRunEventDTO
   */
  ean?: string | null;
  /**
   * The model's own confidence (0.0-1.0). Null when the call returned nothing.
   * @type {number}
   * @memberof DescriptionRunEventDTO
   */
  confidence?: number | null;
  /**
   * Whether the description needed a second pass with Google Search grounding.
   * @type {boolean}
   * @memberof DescriptionRunEventDTO
   */
  grounded: boolean;
  /**
   * Set only on ERROR rows.
   * @type {string}
   * @memberof DescriptionRunEventDTO
   */
  message?: string | null;
  /**
   *
   * @type {string}
   * @memberof DescriptionRunEventDTO
   */
  createdAt: string;
}

/**
 * @export
 */
export const DescriptionRunEventDTOActionEnum = {
  WRITTEN: "WRITTEN",
  SKIPPED: "SKIPPED",
  ERROR: "ERROR",
  CLAIMED_BY_HAND: "CLAIMED_BY_HAND",
  PRODUCT_GONE: "PRODUCT_GONE"
} as const;
export type DescriptionRunEventDTOActionEnum =
  typeof DescriptionRunEventDTOActionEnum[keyof typeof DescriptionRunEventDTOActionEnum];

/**
 * @export
 */
export const DescriptionRunEventDTOSkipReasonEnum = {
  LOW_CONFIDENCE: "LOW_CONFIDENCE",
  BAD_LENGTH: "BAD_LENGTH",
  API_ERROR: "API_ERROR"
} as const;
export type DescriptionRunEventDTOSkipReasonEnum =
  typeof DescriptionRunEventDTOSkipReasonEnum[keyof typeof DescriptionRunEventDTOSkipReasonEnum];

/**
 * Check if a given object implements the DescriptionRunEventDTO interface.
 */
export function instanceOfDescriptionRunEventDTO(value: object): boolean {
  let isInstance = true;
  isInstance = isInstance && "id" in value;
  isInstance = isInstance && "action" in value;
  isInstance = isInstance && "grounded" in value;
  isInstance = isInstance && "createdAt" in value;

  return isInstance;
}

export function DescriptionRunEventDTOFromJSON(json: any): DescriptionRunEventDTO {
  return DescriptionRunEventDTOFromJSONTyped(json, false);
}

export function DescriptionRunEventDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): DescriptionRunEventDTO {
  if (json === undefined || json === null) {
    return json;
  }
  return {
    id: json["id"],
    action: json["action"],
    skipReason: !exists(json, "skipReason") ? undefined : json["skipReason"],
    productId: !exists(json, "productId") ? undefined : json["productId"],
    ean: !exists(json, "ean") ? undefined : json["ean"],
    confidence: !exists(json, "confidence") ? undefined : json["confidence"],
    grounded: json["grounded"],
    message: !exists(json, "message") ? undefined : json["message"],
    createdAt: json["createdAt"]
  };
}

export function DescriptionRunEventDTOToJSON(value?: DescriptionRunEventDTO | null): any {
  if (value === undefined) {
    return undefined;
  }
  if (value === null) {
    return null;
  }
  return {
    id: value.id,
    action: value.action,
    skipReason: value.skipReason,
    productId: value.productId,
    ean: value.ean,
    confidence: value.confidence,
    grounded: value.grounded,
    message: value.message,
    createdAt: value.createdAt
  };
}
